import {CPSConstants} from "commonUtils/enumerations";

export const formInstructionStyle = {
  pleaseSignInText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#242A3C",
    opacity: 1,
    m: "0 0 0 0.313rem",
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMTEXT,
    textAlign: "center",
  },
};
